{
  "moreInformation": {
    "heading": "Additional information"
  },
  "calculationResult": {
    "error": {
      "heading": "We’re not able to give you an indication",
      "description": "With the information you have filled in, we’re not able to give you an indication of how much you can borrow. It might be that income is too low, so feel free to play around with different numbers."
    }
  }
}
